import React from 'react';
import { Route, Switch, useLocation } from 'react-router';
import useDarkMode from 'use-dark-mode';

import NotFound from '@swf/components/StarsModal/NotFound';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton, {
  Variant as CloseVariant
} from '@swf/components/StarsModal/components/CloseButton';
import Header, {
  Variant as HeaderVariant
} from '@swf/components/StarsModal/components/Header/Header';
import { PokerModalRoutes as Routes } from '@swf/core/types/Poker';
import { matchRoute } from '@swf/core/utils/c2l/matchRoute';

import ActionsModal from '../Club/Members/ActionsModal/ActionsModal';
import CreateCashGame from '../CreateGame/CreateCashGame';
import CreateCashGameSuccess from '../CreateGame/Success/CreateCashGameSuccess';
import CreateTournament from '../CreateTournament/CreateTournament';
import CreateTournamentSuccess from '../CreateTournament/CreateTournamentSuccess/CreateTournamentSuccess';
import { CreateClub } from '../MyClubs/CreateClub/CreateClub';
import { CreateClubSuccess } from '../MyClubs/CreateClub/components/CreateClubSuccess/CreateClubSuccess';
import { JoinClub } from '../MyClubs/JoinClub/JoinClub';
import DeleteGamePrompt from '../PokerGameTile/DeleteGame/DeleteGamePrompt';

import styles from './PokerModalRoutes.scss';

const PokerModalRoutes: React.FC = () => {
  const { value: isDarkMode } = useDarkMode();
  const { pathname } = useLocation();
  const isCustomLayout = matchRoute(pathname);

  if (isCustomLayout) {
    return (
      <Switch>
        <Route path={Routes.createCashGameSuccess} component={CreateCashGameSuccess} />
        <Route path={Routes.createCashGame} component={CreateCashGame} />
        <Route path={Routes.createTournamentSuccess} component={CreateTournamentSuccess} />
        <Route path={Routes.createTournament} component={CreateTournament} />
        <Route path={Routes.deleteGamePrompt} component={DeleteGamePrompt} />
        <Route path={Routes.createClubSuccess} component={CreateClubSuccess} />
        <Route path={Routes.createClub} component={CreateClub} />
        <Route path={Routes.joinClub} component={JoinClub} />
        <Route path={Routes.membersAdminActions} component={ActionsModal} />
      </Switch>
    );
  }

  return (
    <>
      <Header
        className={styles.header}
        variant={isDarkMode ? HeaderVariant.Dark : HeaderVariant.Light}
      >
        <CloseButton variant={isDarkMode ? CloseVariant.Light : CloseVariant.Dark} />
      </Header>
      <Body className={styles.body}>
        <Switch>
          <Route component={NotFound} />
        </Switch>
      </Body>
    </>
  );
};

export default PokerModalRoutes;
